import { schema } from 'normalizr';
export var userSchema = new schema.Entity('user', {}, {
    idAttribute: 'userId',
});
export var userListSchema = [userSchema];
//# sourceMappingURL=user.js.map